import "./PageHeader.scss";

const PageHeader = (props: any) => (
    <h1      
      className="header-size">
       {props.children}
    </h1>    
);

export default PageHeader;